<template>
  <div
    :class="`icon-container icon-container--${variant}`"
    @click="$emit('click', $event)"
  >
    <b-icon :class="`icon icon--${variant}`" :icon="icon" />
  </div>
</template>

<script>
import { BIcon } from "bootstrap-vue";
export default {
  name: "icon-button",
  components: { BIcon },
  props: {
    icon: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      required: false,
      default: "primary"
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.icon-container {
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.icon-container--primary {
  background-color: $gyra-salmon;
  height: 40px;
  width: 40px;
}
.icon-container--secondary {
  background-color: $gyra-grey-dark;
  height: 30px;
  width: 30px;
}
.icon {
}
.icon--primary {
  font-size: 28px;
  color: $gyra-grey-dark;
}
.icon--secondary {
  font-size: 24px;
  color: white;
}
</style>
